import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { isLoungePortal } from '@white-label-helper/shared-helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'brand-logo',
  props: {
    homePageUrl: null,
    imageUrl: null,
    altText: null
  },
  setup(__props: any) {

const props = __props as {
  homePageUrl?: string
  imageUrl?: string
  altText?: string
};



const openLinkInNewTab = computed(() => {
  return !isLoungePortal();
})

const homeUrlWithProtocol = computed(() => {
  if (/^https?:\/\//.test(props.homePageUrl)) {
    return props.homePageUrl;
  }

  return `//${props.homePageUrl}`;
});

const keydownSpaceHandler = (e: KeyboardEvent) => {
  if (e.target instanceof HTMLElement) {
    e.target.click()
  }
}

return { __sfc: true,props, openLinkInNewTab, homeUrlWithProtocol, keydownSpaceHandler }
}

})